import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/reply-logo-compact.png'
import _imports_1 from '@/assets/auth-big-img.svg'


const _hoisted_1 = { class: "auth__container" }
const _hoisted_2 = { class: "flex-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "auth__reply-logo",
  src: _imports_0,
  alt: "Reply200"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex-center auth__decoration" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "Welcome"
  })
], -1)

import { watch } from "vue";
import { useAccountStore } from "@/stores/account";
import { useTitle } from "@vueuse/core";
import { useRouter } from "vue-router";
import AuthLoginForm from "@/components/auth/AuthLoginForm.vue";
import AuthRegisterForm from "@/components/auth/AuthRegisterForm.vue";
import AuthConfirmForm from "@/components/auth/AuthConfirmForm.vue";
import AuthSocialForm from "@/components/auth/AuthSocialForm.vue";
import AuthForgotForm from "@/components/auth/AuthForgotForm.vue";
import AuthRecoverForm from "@/components/auth/AuthRecoverForm.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Auth',
  props: {
    signUpPage: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { signUpPage?: boolean }



useTitle("Sign In | Reply200")

const accountStore = useAccountStore()
const router = useRouter()
watch(() => accountStore.status, status => {
  if (status === "authorized") {
    router.push("/")
  }
}, { immediate: true })


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(accountStore).logout()))
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      (props.signUpPage || _ctx.$route.params.page === 'sign-up')
        ? (_openBlock(), _createBlock(AuthRegisterForm, { key: 0 }))
        : (_ctx.$route.params.page === 'confirm')
          ? (_openBlock(), _createBlock(AuthConfirmForm, { key: 1 }))
          : (_ctx.$route.params.page === 'google' || _ctx.$route.params.page === 'facebook')
            ? (_openBlock(), _createBlock(AuthSocialForm, { key: 2 }))
            : (_ctx.$route.params.page === 'forgot')
              ? (_openBlock(), _createBlock(AuthForgotForm, { key: 3 }))
              : (_ctx.$route.params.page === 'recover')
                ? (_openBlock(), _createBlock(AuthRecoverForm, { key: 4 }))
                : (_openBlock(), _createBlock(AuthLoginForm, { key: 5 }))
    ]),
    _hoisted_4
  ]))
}
}

})